import React from "react";
import styles from "../Styles/Refund.css";

export const Refund = () => {
  return (
    <div className="main-refund">
      <h3>Return & Refund Policy</h3>
      <p>
        Thanks for shopping at Ideakart.com.
        <br />
        <br />
        If you are not entirely satisfied with your purchase, we're here to
        help.
      </p>
      <h3>Returns</h3>
      <p>
        You have 7 calendar days to return an item from the date you received
        it.
        <br />
        <br />
        To be eligible for a return, your item must be unused and in the same
        condition that you received it.
        <br />
        <br />
        Your item must be in the original packaging.
        <br />
        Your item needs to have the receipt or proof of purchase.
      </p>
      <h3>Refunds</h3>
      <p>
        Once we receive your item, we will inspect it and notify you that we
        have received your returned item.
        <br />
        <br /> We will immediately notify you on the status of your refund after
        inspecting the item.
        <br /> If your return is approved, we will initiate a refund to your
        method of payment(Credit Card/Debit Card/Bank etc).
        <br />
        <br /> You will receive the credit within a certain amount of days,
        depending on your banks policies.
      </p>
      <h3>Shipping</h3>
      <p>
        You will be responsible for paying for your own shipping costs for
        returning your item. Shipping costs are non­refundable.
        <br />
        <br />
        If you receive a refund, the cost of return shipping will be deducted
        from your refund.
      </p>
      <h3>Contact Us</h3>
      <p>If you have any questions on how to return your item to us, contact us at 9999999999</p>
    </div>
  );
};